import React, { useState } from 'react';
import type { ReactNode, FC } from 'react';

import Button from '@atlaskit/button/new';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import VideoPlayIcon from '@atlaskit/icon/core/video-play';
import type { IconProps } from '@atlaskit/icon';

type HTV2ModalDialogCTAProps = {
	onClick: () => void;
	modalChildren: ReactNode;
	icon: React.ComponentType<IconProps>;
	children?: React.ReactNode;
};
type CTAComponentProps = Omit<HTV2ModalDialogCTAProps, 'modalChildren' | 'icon'>;

const HTV2ModalDialogCTA: FC<HTV2ModalDialogCTAProps> = ({
	onClick,
	children,
	modalChildren,
	icon,
}) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const handleClick = () => {
		setIsOpen(true);
		onClick();
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	return (
		<>
			<Button iconBefore={icon} onClick={handleClick}>
				{children}
			</Button>
			<ModalTransition>
				{isOpen && (
					<Modal onClose={handleClose} width="large" height={600}>
						{modalChildren}
					</Modal>
				)}
			</ModalTransition>
		</>
	);
};

export const HTV2ExploreAICTA: FC<CTAComponentProps> = ({ children, onClick }) => {
	return (
		<HTV2ModalDialogCTA
			onClick={onClick}
			icon={VideoPlayIcon}
			modalChildren={
				<iframe
					width="800"
					height="600"
					src="https://www.youtube.com/embed/ivIV1a8W0e4?si=eku5WF5A3J9pSHO7"
					title="YouTube video player"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					referrerPolicy="strict-origin-when-cross-origin"
					allowFullScreen
				/>
			}
		>
			{children}
		</HTV2ModalDialogCTA>
	);
};
